import * as React from "react";

import {
  AnalyticsConfigurationProvider,
  AnalyticsProvider,
  createAnalyticsContext,
  useAnalyticsOtpGtm,
} from "../../../Common";
import { useReactJoinInitialState } from "../react-join-initial-state-provider";

import { ReactJoinAnalyticsInterface } from "./analytics-interface";

export const [analyticsContext, useReactJoinAnalytics] =
  createAnalyticsContext<ReactJoinAnalyticsInterface>();

const ReactJoinAnalyticsProvider_Implementations: React.FunctionComponent = (
  props
) => {
  const analyticsOtpGtm = useAnalyticsOtpGtm<ReactJoinAnalyticsInterface>();

  const implementations = React.useMemo(
    () => [analyticsOtpGtm],
    [analyticsOtpGtm]
  );

  return (
    <AnalyticsProvider
      context={analyticsContext}
      implementations={implementations}
    >
      {props?.children || []}
    </AnalyticsProvider>
  );
};

export const ReactJoinAnalyticsProvider: React.FunctionComponent = (props) => {
  return (
    <AnalyticsConfigurationProvider useInitialState={useReactJoinInitialState}>
      <ReactJoinAnalyticsProvider_Implementations>
        {props.children || []}
      </ReactJoinAnalyticsProvider_Implementations>
    </AnalyticsConfigurationProvider>
  );
};
